import React, {
  useEffect,
  useState
}                               from 'react';
import { useTranslation }       from 'react-i18next';
import PropTypes                from 'prop-types';
import MonetizationOn           from '@material-ui/icons/MonetizationOn';
import Input                    from '@material-ui/core/Input';
import Paper                    from '~/components/Paper';
import Request                  from '~/providers/Request';
import InputControl             from '~/components/Input/InputControl';
import InputNumber              from '~/components/Input/InputNumber';
import InputSelect              from '~/components/Input/InputSelect';
import GridContainer            from '~/components/GridContainer';
import GridItem                 from '~/components/GridItem';
import Form                     from '~/containers/Form';
import InputCheckBox            from '~/components/Input/InputCheckBox';
import AddonRecord              from '~/records/AddonRecord';
import packageTypesEnum         from '~/enums/packageTypesEnum';
import packagePeriodEnum         from '~/enums/packagePeriodEnum';
import langsEnum                from '~/enums/langsEnum';
import coinsEnum                from '~/enums/coinsEnum';

const attrName = (attr) => AddonRecord.hummanAttributeName(attr);

function AddonItem({record, handleChange, loading, onSubmit, setRecord }) {
  const [partner, setPartner] = useState('');
  const [partnersArray, setPartnersArray] = useState('');
  const { t } = useTranslation();
  const isPersisted = record.isPersisted();

  useEffect(() => {
    Request.get('/admin/partner').then((result) => {
      const data = [
        ...result.data,
        {id: null, code: '', name: 'Sem Vínculo'}
      ];
      setPartnersArray(data);

      if (record.get('partner_id')) {
        setPartner(data.find(partner => partner.id === String(record.get('partner_id'))).name);
      }
    });
  }, [record.get('partner_id')]);

  return (
    <Form onSubmit={onSubmit} isPersisted={isPersisted}>
      <Paper
        Icon={MonetizationOn}
        iconColor={isPersisted ? 'purple' : 'green'}
        title={t('addon.defSingular')}
        loading={loading}
      >
        <GridContainer>
          <GridItem xs={12} md={9}>
            <InputControl
              name='name'
              value={record.get('name')}
              disabled={loading}
              required={true}
              label={attrName('name')}
              inputComponent={Input}
              onChange={handleChange}
            />
          </GridItem>
          <GridItem xs={12} md={2}>
            <InputControl
              value={record.get('resources_size')}
              name="resources_size"
              required={true}
              label={attrName('resources_size')}
              disabled={loading}
              inputComponent={InputNumber}
              InputProps={{
                config:{allowDecimal: false, requireDecimal: false},
              }}
              onChange={handleChange}
            />
          </GridItem>

          <GridItem xs={6} md={1}>
            <InputControl
              value={record.get('is_active')}
              name="is_active"
              disabled={loading}
              label={attrName('is_active')}
              inputComponent={InputCheckBox}
              onChange={handleChange}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} md={3}>
            <InputControl
              value={record.get('lang')}
              name="lang"
              disabled={loading}
              required={true}
              label={attrName('lang')}
              inputComponent={InputSelect}
              InputProps={{
                options: langsEnum().array,
                placeholder: t('addon-language-placeholder'),
                outValueType: 'string'
              }}
              onChange={handleChange}
            />
          </GridItem>

          <GridItem xs={12} md={3}>
            <InputControl
              value={record.get('type')}
              name="type"
              disabled={loading}
              required={true}
              label={attrName('type')}
              inputComponent={InputSelect}
              InputProps={{
                options: packageTypesEnum().array,
                placeholder: t('addon.type.placeholder'),
                outValueType: 'string'
              }}
              onChange={handleChange}
            />
          </GridItem>

          <GridItem xs={12} md={3}>
            <InputControl
              value={record.get('coin')}
              name="coin"
              disabled={loading}
              label={attrName('coin')}
              required={true}
              inputComponent={InputSelect}
              InputProps={{
                options: coinsEnum().array,
                placeholder: t('currency.placeholder'),
                outValueType: 'string'
              }}
              onChange={handleChange}
            />
          </GridItem>

          <GridItem xs={12} md={3}>
            <InputControl
              value={record.get('price')}
              name="price"
              disabled={loading}
              required={true}
              label={attrName('price')}
              inputComponent={InputNumber}
              onChange={handleChange}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} md={6}>
            <InputControl
              value={record.get('google_product_id')}
              name="google_product_id"
              required={true}
              label={attrName('google_product_id')}
              inputComponent={Input}
              disabled={loading}
              onChange={handleChange}
            />
          </GridItem>

          <GridItem xs={12} md={6}>
            <InputControl
              value={record.get('apple_product_id')}
              name="apple_product_id"
              required={true}
              label={attrName('apple_product_id')}
              inputComponent={Input}
              disabled={loading}
              onChange={handleChange}
            />
          </GridItem>

          <GridItem xs={6}>
            <InputControl
              label={attrName('partner_id')}
              value={partner}
              name={'partner_id'}
              inputComponent={InputSelect}
              onChange={({partner_id}) => {
                setRecord(record.updateAttributes({ partner_id: partner_id.id }));
                setPartner(partner_id.name);
              }}
              InputProps={{
                options: partnersArray,
                outValueType: 'object',
              }}
            />
          </GridItem>

          <GridItem xs={12} md={3}>
            <InputControl
              value={record.get('period')}
              name="period"
              disabled={loading}
              label={attrName('period')}
              inputComponent={InputSelect}
              InputProps={{
                options: packagePeriodEnum().array,
                outValueType: 'string'
              }}
              onChange={handleChange}
            />
          </GridItem>
        </GridContainer>
      </Paper>
    </Form>
  );
}

AddonItem.propTypes={
  loading:      PropTypes.bool,
  record:       PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit:     PropTypes.func.isRequired,
};

AddonItem.defaultProps={
  loading: false,
};
export default AddonItem;
